/* eslint-disable max-len */
import React from "react"
import { Link } from "gatsby"
import { Icon } from "../Icon/Icon"
import { useState } from "react"
import { navigate } from "gatsby"
import styled from "styled-components"
import PropTypes from "prop-types"

const OverlayMenu = props => {
  const { displayMenu, navMenuData, employeePage } = props
  const data = navMenuData
  const wpMenu = employeePage ? data.employeeMenu : data.mainMenu
  const menu = wpMenu.menuItems.nodes

  const Overlay = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${displayMenu ? "1" : "0"};
  transform: ${displayMenu ? "translateX(0%)" : "translateX(-100%)"};
  z-index: 100000;
  top: 75px;
  border: 1px solid var(--lightGrey);
  left: 0px;
  transition: all 0.3s ease;
  display: ${displayMenu ? "block" : "none"};
  button {
    appearance: none;
    border: none;
  }

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--darkGrey);
    width: 100%;
    height: 100%;
    color: var(--illiniDarkBlue);
  }

    .invertedLogo {
      max-width: 200px;
      margin: 0 0 60px 0;
    }

    .nav {
      width: 100%;
      padding: 1rem;
      border-top: 1px solid grey;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0;
    }

    .nav-active {
      background: #fff;
      color: var(--illiniOrange);
    }
    .nav div {
      margin-left: 1rem;
    }
    .active {
      padding-top: 1rem;
      display: block !important;
      width: 100%;
      background: #fff;
      text-align:left;

    margin-bottom:1rem;
    }

    .active li {
      padding: 0.5rem;
      background: #fff;
      list-style: disc;
            margin-top:1rem;
    }
    .nav ul {
      display: none;
    }
    button {
      -webkit-appearance: none;
      outline:none;
      border:none;
    }

    .overlayMenu {
      text-align: left;
      list-style-type: none;
      margin: 0;
      width: 100%;
    }
  }

  .closeButton {
    position: absolute;
    top: 50px;
    right: 50px;
    color: #fff;
    width: 30px;
    height: 30px;
    cursor: pointer;
    transition: all 1s ease;
    outline: none;

    :hover {
      transform: rotate(180deg);
    }
  }
`
  const i = 0

  function searchRedirect() {
    navigate("/Search")
  }

  function keydownSearch(event) {
    if (event.keyCode === 13) {
      navigate("/Search")
    }
  }

  function serviceRedirect() {
    navigate("https://my.fs.illinois.edu/fsportal/portal/service-request")
  }

  function keydownService(event) {
    if (event.keyCode === 13) {
      navigate("https://my.fs.illinois.edu/fsportal/portal/service-request")
    }
  }
  return (
    <Overlay>
      <div className="inner">
        <ul className="overlayMenu">
          {menu.map(mainItem =>
            !mainItem.parentId // pass main item to the click handler so each item gets its own click handler
              ? ClickHandler(mainItem, i)
              : null
          )}
          <li>
            <button
              key="Request a Service"
              onClick={serviceRedirect}
              onKeyDown={keydownService}
              className="nav primaryLink"
            >
              Request a Service
            </button>
          </li>
          <li>
            <button
              key="search"
              href=""
              onClick={searchRedirect}
              onKeyDown={keydownSearch}
              className="nav primaryLink"
            >
              Search
            </button>
          </li>
        </ul>
      </div>
    </Overlay>
  )
}

function ClickHandler(mainItem, i) {
  const [click, setClick] = useState(false)
  const handleClick = () => setClick(!click)

  function keydown(event) {
    if (event.keyCode === 13) {
      setClick(!click)
    }
  }

  return (
    // build menu item and child menu
    <li key={mainItem.id}>
      <button
        href=""
        key={mainItem.id}
        onClick={handleClick}
        onKeyDown={keydown}
        className={click ? "nav nav-active primaryLink" : "nav primaryLink"}
      >
        {mainItem.label}
        {mainItem.childItems.nodes.length !== 0 && click ? (
          <div>
            <Icon category="Up Arrow" />
          </div>
        ) : (
          <div>
            <Icon category="Down Arrow" />
          </div>
        )}
        {mainItem.childItems.nodes.length !== 0 ? (
          <ul className={click ? "active" : ""}>
            {mainItem.childItems.nodes.map(childItem => (
              <li key={childItem.id}>
                {childItem.url.charAt(0) === "/" ? (
                  <Link
                    to={childItem.url}
                    activeClassName="nav-active"
                    className="secondaryLink"
                  >
                    {childItem.label}
                  </Link>
                ) : (
                  <a href={childItem.url} className="secondaryLink">
                    {childItem.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        ) : null}
      </button>
    </li>
  )
}

OverlayMenu.propTypes = {
  displayMenu: PropTypes.bool,
}

export default OverlayMenu
